/** @jsx isolateComponent */
import gql from 'graphql-tag';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Alert, Link } from '@zapier/design-system';

import type { ApolloCache } from '../types';
import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';
import { BannerProps } from './types';

export const shouldRender = (data: Result['data']) => {
  const { currentUser, currentAccount } = data;
  return (
    !currentUser.hasSeenNotifications.jobsCta &&
    !currentAccount.isCompanyAccount
  );
};

export const setHasSeenJobsCtaMutation = gql`
  mutation setHasSeenJobsCta($profileId: ID!, $hasSeenCta: Boolean!) {
    setHasSeenJobsCta(id: $profileId, hasSeenCta: $hasSeenCta) {
      id
      hasSeenNotifications {
        jobsCta
      }
    }
  }
`;

export const Component = function JobsHiring(props: BannerProps) {
  const defaultMutationReturnData = {
    id: props.data.currentAccount.id,
    hasSeenNotifications: {
      jobsCta: props.data.currentUser.hasSeenNotifications.jobsCta,
    },
  };
  const [setHasSeenJobsCta] = props.useMutation(setHasSeenJobsCtaMutation, {
    update: (cache: ApolloCache, { data = defaultMutationReturnData }) => {
      cache.modify({
        id: cache.identify(data),
        fields: {
          hasSeenNotifications(hasSeenNotifications = {}) {
            return {
              ...hasSeenNotifications,
              jobsCta: data.hasSeenNotifications.jobsCta,
            };
          },
        },
      });
    },
  });
  const onDismiss = () => {
    setHasSeenJobsCta({
      variables: {
        profileId: props.data.currentUser.id,
        hasSeenCta: true,
      },
    });
  };
  const title = (
    <span>
      We’re hiring — <Link href="/about">work remotely</Link>!
    </span>
  );
  return (
    <Alert
      layout={props.layout}
      onDismiss={onDismiss}
      title={title}
      type="info"
    />
  );
};
